import { toast } from 'sonner'

export const getPickupAreas = async (id?: string) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/companies/${id}/pickup_areas`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

export const getPickupAreasData = async (page?: number) => {
  try {
    const response = await fetch(`${process.env.API_URL}/pickup_areas`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

export const addPickupArea = async (pickupData: any) => {
  try {
    const response = await fetch(`${process.env.API_URL}/pickup_areas`, {
      method: 'POST',
      body: JSON.stringify(pickupData),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const responseData = await response.json()
    toast.success('Pickup Area Created Successfully')
    return responseData
  } catch (error) {
    console.error('Error:', error)
    return { error: error }
  }
}

export const updatePickupArea = async (pickupData: any, id: string) => {
  try {
    const response = await fetch(`${process.env.API_URL}/pickup_areas/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(pickupData),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const responseData = await response.json()
    toast.success('Pickup Area Updated Successfully')
    return responseData
  } catch (error) {
    console.error('Error:', error)
    return { error: error }
  }
}

export const getOnePickupArea = async (id: string) => {
  try {
    const response = await fetch(`${process.env.API_URL}/pickup_areas/${id}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const responseData = await response.json()
    return responseData
  } catch (error) {
    toast.error("Can't get Pickup Area")
    console.error('Error:', error)
    return { error: error }
  }
}
export const getWareaHouse = async (id?: string) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/companies/${id}/warehouses`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

export const getWareaHouseData = async (page?: number) => {
  try {
    const response = await fetch(`${process.env.API_URL}/warehouses`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

export const addWarehouse = async (warehouseData: any) => {
  try {
    const response = await fetch(`${process.env.API_URL}/warehouses`, {
      method: 'POST',
      body: JSON.stringify(warehouseData),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const responseData = await response.json()
    toast.success('Warehouse Created Successfully')
    return responseData
  } catch (error) {
    console.error('Error:', error)
    return { error: error }
  }
}

export const updateWarehouse = async (warehouseData: any, id: string) => {
  try {
    const response = await fetch(`${process.env.API_URL}/warehouses/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(warehouseData),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const responseData = await response.json()
    toast.success('Warehouse Updated Successfully')
    return responseData
  } catch (error) {
    console.error('Error:', error)
    return { error: error }
  }
}

export const getOneWarehouse = async (id: string) => {
  try {
    const response = await fetch(`${process.env.API_URL}/warehouses/${id}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const responseData = await response.json()
    return responseData
  } catch (error) {
    toast.error("Can't get Warehouse")
    console.error('Error:', error)
    return { error: error }
  }
}

export const deletePickupArea = async (id: string) => {
  try {
    const response = await fetch(`${process.env.API_URL}/pickup_areas/${id}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const responseData = await response.json()
    toast.success('PickupArea Deleted Successfully')
    return responseData
  } catch (error) {
    toast.error('Error While Deleting PickupArea')
    console.error('Error:', error)
    return { error: error }
  }
}

export const deleteWarehouse = async (id: string) => {
  try {
    const response = await fetch(`${process.env.API_URL}/warehouses/${id}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const responseData = await response.json()
    toast.success('Warehouse Deleted Successfully')
    return responseData
  } catch (error) {
    toast.error('Error While Deleting Warehouse')
    console.error('Error:', error)
    return { error: error }
  }
}

export const addScheduleLine = async (scheduleData: any) => {
  try {
    const response = await fetch(`${process.env.API_URL}/transport_schedules`, {
      method: 'POST',
      body: JSON.stringify(scheduleData),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const responseData = await response.json()
    toast.success('Schedule Line Created Successfully')
    return responseData
  } catch (error) {
    console.error('Error:', error)
    return { error: error }
  }
}

export const getTransportScheduleData = async (page?: number) => {
  try {
    const response = await fetch(`${process.env.API_URL}/transport_schedules`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

export const getOneScheduleData = async (id: string) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/transport_schedules/${id}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const responseData = await response.json()
    return responseData
  } catch (error) {
    toast.error("Can't get Transport Schedules")
    console.error('Error:', error)
    return { error: error }
  }
}

export const updateScheduleData = async (scheduleData: any, id: string) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/transport_schedules/${id}}`,
      {
        method: 'PATCH',
        body: JSON.stringify(scheduleData),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const responseData = await response.json()
    toast.success('Transport Schedules Updated Successfully')
    return responseData
  } catch (error) {
    console.error('Error:', error)
    return { error: error }
  }
}

export const deleteScheduleData = async (id: string) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/transport_schedules/${id}`,
      {
        method: 'DELETE',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const responseData = await response.json()
    toast.success('Schedule Data Deleted Successfully')
    return responseData
  } catch (error) {
    toast.error('Error While Deleting ScheduleData')
    console.error('Error:', error)
    return { error: error }
  }
}

export const getTransportSchedule = async (id: string) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/companies/${id}/transport_schedules`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}
